const paperGenerationEn = {
    question: require('../../lang/en/paper_generation/Question').default,
    questionBank: require('../../lang/en/paper_generation/QuestionBank').default,
    exam: require('../../lang/en/paper_generation/Exam').default,
    examQuestion: require('../../lang/en/paper_generation/ExamQuestion').default,
    testDesigner: require('../../lang/en/paper_generation/TestDesigner').default,
};

export default paperGenerationEn;
